module.exports = __webpack_public_path__ + "img/bg-flecha-siguiente.8336dbd0.png";